import React from "react";
import "./App.scss";
import Routes from "./Routes";

//REACT-REDUX
import { initStore } from "@gsd/redux-store-backoffice";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify-redux";
import "react-toastify/dist/ReactToastify.css";
import Toast from "./component/toast/Toast";
import AutoLoginHandler from "./containers/AutoLoginHandler";

const App = () => {
  return (
    <Provider store={initStore("idm")}>
      <React.Fragment>
        <AutoLoginHandler />
        <Routes />
        <ToastContainer
          position="top-center"
          progressClassName={"bg-gradient-primary"}
          className="px-3"
          toastClassName="rounded shadow bg-dark"
          toastComponent={Toast}
          closeButton={false}
          autoClose={4000}
        />
      </React.Fragment>
    </Provider>
  );
};
export default App;
